'use client';

import { useState } from 'react';

import { Check, Copy } from 'lucide-react';

export function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button type="button"
      onClick={copyToClipboard}
      className='absolute top-3 right-3 z-20 rounded-lg border border-black/10 bg-black/5 p-2 opacity-0 backdrop-blur-sm transition-all group-hover:opacity-100 hover:bg-black/10 dark:border-white/10 dark:bg-white/10 dark:hover:bg-white/20'
      aria-label='Copy code'>
      {copied ? (
        <Check className='size-4 text-emerald-600 dark:text-emerald-400' />
      ) : (
        <Copy className='size-4 text-slate-500 dark:text-gray-300' />
      )}
    </button>
  );
}
